module.exports = __webpack_public_path__ + "img/icon-logout.74ec3a6a.svg";